module["exports"] = [
  "30[0-5]#-######-###L",
  "36##-######-###L",
  "54##-####-####-###L"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/finance/credit_card/diners_club.js
// module id = 2649
// module chunks = 1610